import { render, staticRenderFns } from "./PageLayoutTemplate.vue?vue&type=template&id=538c64bd"
import script from "./PageLayoutTemplate.vue?vue&type=script&lang=js"
export * from "./PageLayoutTemplate.vue?vue&type=script&lang=js"
import style0 from "./PageLayoutTemplate.vue?vue&type=style&index=0&id=538c64bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports